module.exports = __webpack_public_path__ + "ad735fca4e2f5e793e3db09932fb3375.svg";